var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0411 41.9553C37.1768 45.4991 32.0975 47.7392 26.5 47.9787V45H24.5V47.9787C18.819 47.7356 13.6717 45.4318 9.78676 41.7958L11.5897 39.9928L10.1755 38.5786L8.3869 40.3672C4.93446 36.5251 2.75723 31.514 2.52135 26H5.5V24H2.52135C2.75311 18.5825 4.8589 13.6503 8.20694 9.83544L10.1754 11.8039L11.5896 10.3897L9.59025 8.39032C13.4973 4.64691 18.7226 2.2685 24.5 2.02135V5H26.5V2.02135C32.3737 2.27262 37.6767 4.72679 41.604 8.57865L39.793 10.3897L41.2072 11.8039L42.9708 10.0403C46.2155 13.8262 48.251 18.679 48.4787 24H45.5V26H48.4787C48.2392 31.5975 45.9991 36.6768 42.4553 40.5411L40.4928 38.5786L39.0786 39.9928L41.0411 41.9553ZM50.5 25C50.5 38.8071 39.3071 50 25.5 50C11.6929 50 0.5 38.8071 0.5 25C0.5 11.1929 11.6929 0 25.5 0C39.3071 0 50.5 11.1929 50.5 25ZM26.5 21.5705C27.9857 22.0029 29.0714 23.3747 29.0714 25C29.0714 25.6227 28.9121 26.2081 28.632 26.7178L38.4515 36.5373L37.0373 37.9515L27.2178 28.132C26.7081 28.4121 26.1227 28.5714 25.5 28.5714C23.5276 28.5714 21.9286 26.9724 21.9286 25C21.9286 23.3747 23.0143 22.0029 24.5 21.5705V7.85714H26.5V21.5705ZM27.0714 25C27.0714 25.8679 26.3679 26.5714 25.5 26.5714C24.6321 26.5714 23.9286 25.8679 23.9286 25C23.9286 24.1321 24.6321 23.4286 25.5 23.4286C26.3679 23.4286 27.0714 24.1321 27.0714 25Z",
    fill: "#043F93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.7cd3f54a4ded230d694598b07b22706c.svg";
export { ForwardRef as ReactComponent };